import { http, HttpResponse, delay } from 'msw';

import { packages } from '../data/packagesData';

export const packageHandlers = [
  http.get('*/v1/packages', async () => {
    console.log(packages);
    await delay();
    return HttpResponse.json(packages, { status: 200 });
  }),
  http.get('*/v1/organizations/:id/packages', async () => {
    await delay();
    return HttpResponse.json(
      [
        {
          id: 'org-pkg-1',
          organization_id: 'simple-org-id',
          package: {
            id: packages[0].id,
            name: packages[0].name,
            sku: packages[0].sku,
            display_name: packages[0].display_name,
            entitlements: [],
          },
          license_count: 100,
          available_license_count: 50,
        },
      ],
      { status: 200 }
    );
  }),
  http.patch('*/v1/organizations/:id/packages', async () => {
    await delay();
    return new HttpResponse(null, { status: 200 });
  }),
  http.post('*/v1/organizations/:id/packages', async () => {
    await delay();
    return new HttpResponse(null, { status: 200 });
  }),
  http.patch(
    '*/v1/organizations/:id/packages/:organizationPackageId',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 200 });
    }
  ),
  http.delete(
    '*/v1/organizations/:id/packages/:organizationPackageId',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),
  http.post(
    '*/v1/organizations/:id/packages/send_change_license_count_interest_email',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 200 });
    }
  ),
  http.post('*/v1/organizations/:id/packages/upgrade', async () => {
    await delay();
    return new HttpResponse(null, { status: 200 });
  }),
];
